// CONSTANTS are all caps.
const NS = 'ProductItemWidget';
const CLS = 'productItemWidget';
const WG = '.' + CLS + '-';
const CLS_HOV_IMG = 'has-hoverImg';

import _ from 'lodash';

export class ProductItemWidget {
	constructor(element) {
		this.element = element;
		this.$el = $(element);
		this.$content = this.$el.find(`${WG}content`);
		this.$imgBg = this.$el.find(`${WG}imgBg`);

		this.checkHoverImage();
	}

	checkHoverImage() {
		if (this.$el.find(`${WG}imgBgHover`).length > 0) {
			this.$el.addClass(CLS_HOV_IMG);
		}
	}
}
